import { CheckIcon, SkipForwardIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import type { SlotItem } from "../../dashboard/utils";
import { useSlotMutations } from "../../dashboard/hooks/useSlotMutations";

interface CloseOutActionsProps {
  readonly item: SlotItem;
}

export function CloseOutActions({ item }: CloseOutActionsProps) {
  const { complete, completeRecovery, skip, isLoading } = useSlotMutations(
    item.goalId,
    item.slot.id,
  );

  return (
    <div className="flex flex-col gap-2">
      {item.slot.recoveryAction && (
        <Button
          size="lg"
          disabled={isLoading}
          onClick={() => completeRecovery.mutate()}
        >
          <CheckIcon strokeWidth={3} />
          <span className="truncate">Did recovery: {item.slot.recoveryAction}</span>
        </Button>
      )}
      <Button
        size="lg"
        variant={item.slot.recoveryAction ? "secondary" : "default"}
        disabled={isLoading}
        onClick={() => complete.mutate()}
      >
        <CheckIcon strokeWidth={3} />
        Did it
      </Button>
      <Button
        size="lg"
        variant="ghost"
        disabled={isLoading}
        onClick={() => skip.mutate()}
        className="text-muted-foreground"
      >
        <SkipForwardIcon />
        Skip today
      </Button>
    </div>
  );
}
